module.exports = __webpack_public_path__ + "img/roadmap1.c90939bb.png";